// Produit en maintenance (orange) ou hors service (rouge), réglé dans Panel
// admin > Boutique : l'achat est désactivé partout (le serveur le refuse aussi).
const BLOCKED = {
  maintenance: {
    button: "En maintenance : achat indisponible",
    short: "En maintenance",
    text: "Ce produit est en maintenance : l'achat est momentanément désactivé. Reviens un peu plus tard.",
    cls: "bg-amber-500/15 text-amber-200 border border-amber-500/40",
  },
  outage: {
    button: "Hors service : achat indisponible",
    short: "Hors service",
    text: "Ce produit est hors service pour le moment : l'achat est désactivé jusqu'au retour à la normale.",
    cls: "bg-red-500/15 text-red-200 border border-red-500/40",
  },
};

/** Infos d'affichage si le produit ne peut pas être acheté (sinon null). */
export const saleBlock = (product) => BLOCKED[product?.status] || null;
